module.exports = __webpack_public_path__ + "static/media/TeacherLogo.b4905b3b.png";